"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importStar(require("styled-components"));

var Icon_1 = require("../Icon/Icon");

var CheckBoxContainer = styled_components_1.default(react_native_1.TouchableOpacity)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 32px;\n    height: 32px;\n    padding: 5px 6px;\n"], ["\n    width: 32px;\n    height: 32px;\n    padding: 5px 6px;\n"])));
var iconNamesEnum;

(function (iconNamesEnum) {
  iconNamesEnum["checked"] = "checkbox-marked";
  iconNamesEnum["empty"] = "checkbox-blank-outline";
})(iconNamesEnum || (iconNamesEnum = {}));

var CheckBox = function CheckBox(props) {
  var isChecked = props.isChecked,
      action = props.action,
      theme = props.theme,
      accessibilityLabel = props.accessibilityLabel,
      selectedAccessibilityLabel = props.selectedAccessibilityLabel;
  var color = isChecked ? theme.colors.purple : theme.colors.gray; // Determine which accessibility label to use

  var computedAccessibilityLabel = isChecked ? selectedAccessibilityLabel || accessibilityLabel : accessibilityLabel;
  return react_1.default.createElement(CheckBoxContainer, {
    onPress: action,
    accessibilityLabel: computedAccessibilityLabel
  }, react_1.default.createElement(Icon_1.Icon, {
    name: isChecked ? iconNamesEnum.checked : iconNamesEnum.empty,
    size: Icon_1.IconSizeEnum.small,
    color: color
  }));
};

exports.default = styled_components_1.withTheme(CheckBox);
var templateObject_1;